// Action creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
import { ActionCreatorLoaderContext } from "../../contexts/ActionCreatorLoaderContext";
import { InteractionTrackerContext } from "@ms/planner-presentational-controls/lib/local/hooks/useInteractionTracker";
// Utilities
import { useNullSafeContext } from "@ms/planner-generic-controls/lib/local/hooks/useNullSafeContext";
import * as React from "react";
/**
 * Supplies {@link useInteractionTracker} to the tree.
 *
 * The interface lives low enough for presentational controls to consume; this provider holds the
 * implementation, which needs the action creator loader.
 */ export const InteractionTrackerProvider = ({ children })=>{
    const acLoader = useNullSafeContext(ActionCreatorLoaderContext);
    const tracker = React.useMemo(()=>({
            startInteraction: (interactionId, targetViewId, entryPoint, extraData)=>acLoader.load(ActionCreator.PerformanceCollection).startInteraction(interactionId, targetViewId, entryPoint, extraData),
            completeInteractions: (targetViewId, renderState)=>acLoader.load(ActionCreator.PerformanceCollection).completeInteractions(targetViewId, renderState),
            cancelInteractions: (targetViewId)=>acLoader.load(ActionCreator.PerformanceCollection).cancelInteractions(targetViewId)
        }), [
        acLoader
    ]);
    return /*#__PURE__*/ React.createElement(InteractionTrackerContext.Provider, {
        value: tracker
    }, children);
};
